import type { SupportTicketStatus } from "../supportTicketTypes";

/**
 * Human-readable labels for support ticket workflow statuses.
 */
export const SUPPORT_TICKET_STATUS_LABELS: Record<SupportTicketStatus, string> =
  {
    open: "Open",
    in_progress: "In Progress",
    onshore_assistance: "Onshore Assistance",
    resolved: "Resolved",
    archived: "Archived",
  };

/**
 * Statuses shown in the editable status dropdown (excludes archive, which has its own action).
 */
export const SUPPORT_TICKET_EDITABLE_STATUSES: SupportTicketStatus[] = [
  "open",
  "in_progress",
  "onshore_assistance",
  "resolved",
];

/**
 * Background and text colors for support ticket status badges.
 */
export const SUPPORT_TICKET_STATUS_TAG_COLORS: Record<
  SupportTicketStatus,
  { backgroundColor: string; textColor: string }
> = {
  open: {
    backgroundColor: "#FFF3E0",
    textColor: "#C24400",
  },
  in_progress: {
    backgroundColor: "#FFF3E0",
    textColor: "#C24400",
  },
  onshore_assistance: {
    backgroundColor: "#F3E8FF",
    textColor: "#6B21A8",
  },
  resolved: {
    backgroundColor: "#EAF3FF",
    textColor: "#0052CC",
  },
  archived: {
    backgroundColor: "#F0F0F0",
    textColor: "#5F6368",
  },
};
